import {IntegrationsContainerSliceDefaultPrimaryCategoriesItem} from 'prismicio-types'
import {useWindowSize} from 'react-use'
import {BREAKPOINTS} from 'src/common/constants'
import {CustomSelect} from './CustomSelect'
import {ButtonList} from './ButtonList'
import {TrackingProps} from 'src/common/helpers'

export const CategoryList = ({
  categories,
  selectedCategory,
  onClick,
  trackingData,
}: {
  categories: IntegrationsContainerSliceDefaultPrimaryCategoriesItem[] | Record<'category_name', string>[]
  selectedCategory: number
  onClick: (index: number) => void
  trackingData: Omit<TrackingProps, 'location' | 'event'>
}) => {
  const isMobile = useWindowSize().width < BREAKPOINTS.TABLET

  return isMobile ? (
    <CustomSelect
      trackingData={trackingData}
      options={categories}
      activeIndex={selectedCategory}
      setActiveIndex={onClick}
      v2
    />
  ) : (
    <ButtonList
      trackingData={trackingData}
      categories={categories}
      selectedCategory={selectedCategory}
      onClick={onClick}
    />
  )
}
